"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchButton = require("./SearchButton");

var _default = _SearchButton.SearchButton;
exports["default"] = _default;